import {
    HubConnection,
    HubConnectionBuilder,
    LogLevel,
    HttpTransportType,
    IHttpConnectionOptions,
} from "@aspnet/signalr";
import { app, alarm, enrollState, sensor } from "@/store";
import {
    AlarmStatus,
    ILocationFromParticle,
    IMiscInfo,
    IStatusChange,
    mapJsonToAlarmStatus,
} from "@/models/AlarmStatus";
import { configureOidc } from "@/store/services/security.service";
import { Log } from "./Logging";
let connectionObj = null as HubConnection | null;

export async function configureMessageHub() {
    if (connectionObj) return Promise.resolve(connectionObj);
    const mainOidc = await configureOidc();
    const options: IHttpConnectionOptions = {
        accessTokenFactory: getAcessToken,
        skipNegotiation: true,
        transport: HttpTransportType.WebSockets,
    };
    const connection = new HubConnectionBuilder()
        .withUrl(`${mainOidc.appUrl}hubs/message`, options)
        .configureLogging(LogLevel.Debug)
        .build();

    connection.on("SendNotificationToClient", (value) => {
        app.error = value;
    });
    connection.on("SetArmOrDisarmOnClient", (value) => {
        alarm.setArmed(value);
    });
    connection.on("SetStatusOnClient", (value: string) => {
        if (value !== "") {
            Log.information("SetStatusOnClient: " + value);
            const status: AlarmStatus = mapJsonToAlarmStatus(value);
            Log.information(status.VSupplies.toString());
            //const status: AlarmStatus = JSON.parse(value);
            status.fetchAt = new Date();
            alarm.SetStatus(status);
        }
    });
    connection.on("StartEnroll", (value: string) => {
        if (value !== "") {
            enrollState.start();
        }
    });
    connection.on("EndEnroll", (value: string) => {
        if (value !== "") {
            enrollState.end();
        }
    });
    connection.on("EnrollTimedOut", (value: string) => {
        if (value !== "") {
            alarm.NewDeviceTimedOut();
        }
    });
    connection.on("DeviceAdded", (value: string) => {
        if (value !== "") {
            alarm.NewDeviceAdded();
            enrollState.end();
        }
    });
    connection.on("UpdatePosition", (value: string) => {
        if (value !== "") {
            const location: ILocationFromParticle = JSON.parse(value);
            alarm.SetCurrentLocation(location);
        }
    });
    connection.on("UpdateMiscInfo", (value: string) => {
        if (value !== "") {
            const miscInfo: IMiscInfo = JSON.parse(value);
            alarm.SetCurentMiscInfo(miscInfo);
        }
    });

    const handleStatusChange = (value: string, onAlarm = false) => {

        if (value === "") {
            console.warn("Status value is empty, returning early.");
            return;
        }

        const statusChange: IStatusChange = JSON.parse(value);
        sensor.SetSensorAge(statusChange);

        if (!sensor.devices || sensor.devices.length === 0) {
            console.warn("Status change no devices found, returning early.");
            return;
        }

        const senderDevice = sensor.devices.find(
            (i) => i.attachedDeviceId === statusChange.device
        );

        if (onAlarm) {
            alarm.SetAlarmOrigin(senderDevice.attachedDeviceTypeId);
            alarm.SetAlarmModeTriggered(true);
        }

        const statusMap = {
            "1": { "0020": alarm.SetHatchState, "0021": alarm.SetHatchState },
            "2": {
                "0000": alarm.SetShorePowerState,
                "0001": alarm.SetShorePowerState,
            },
            "3": {
                "0000": alarm.SetSmartPlugState,
                "0001": alarm.SetSmartPlugState,
            },
            "10": { "0020": alarm.SetDoorState, "0021": alarm.SetDoorState },
            "15": {
                "0000": alarm.SetGasValveState,
                "0001": alarm.SetGasValveState,
            },
            "16": {
                "0000": alarm.SetDigitalIOState,
                "0001": alarm.SetDigitalIOState,
            },
        };

        const deviceTypeId = senderDevice.attachedDeviceTypeId.toString();

        if (
            statusMap[deviceTypeId] &&
            statusMap[deviceTypeId][statusChange.status]
        ) {
            const statusFunc = statusMap[deviceTypeId][statusChange.status];
            statusFunc.call(
                alarm,
                statusChange.status === "0001" || statusChange.status === "0020"
            );
        } else {
            console.warn(
                `No matching status found for device type ${deviceTypeId} and status ${statusChange.status}`
            );
        }
    };

    connection.on("UpdateStatusChange", handleStatusChange);

    connection.on("UpdateStatusChangeOnAlarm", (value: string) =>
        handleStatusChange(value, true)
    );
    connection.on("UpdateAgingDev", handleStatusChange);

    connection.on("ShowMessage", (msg: string) => {
        if (msg !== "") {
            app.success = msg;
        }
    });
    connection.on("ShowError", (msg: string) => {
        if (msg !== "") {
            app.error = msg;
        }
    });
    connection.on("SetPowerStatusOnClient", (value: string) => {
        const values = value.split("|");
        sensor.SetSensorStatus({ id: values[0], value: values[1] });
    });

    connection.onclose(() => startConnection(connection));
    connectionObj = connection;
    await startConnection(connectionObj);
    return connectionObj;
}
const getAcessToken = async (): Promise<string> => {
    const mainOidc = await configureOidc();
    return mainOidc.accessToken;
};
const startConnection = async (connection: HubConnection) => {
    if (connection) {
        const startedPromise: Promise<void> = connection
            .start()
            .catch((err) => {
                Log.error("Failed to connect with hub", err);
                return new Promise((resolve, reject) =>
                    setTimeout(
                        () =>
                            startConnection(connection)
                                .then(() => {
                                    //connectionObj = connection;
                                    resolve;
                                })
                                .catch(reject),
                        5000
                    )
                );
            });
        return startedPromise;
    }
};
